/**
 * Mise en forme du texte des contenus (src/content) : **gras**, ==surlignage== et [libellé](/chemin ou https://…).
 * Le texte est d'abord échappé : seul ce balisage produit du HTML, les contenus ne peuvent pas injecter autre chose.
 */
function escapeHtml(text) {
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

export function inline(text) {
    let html = escapeHtml(text);
    html = html.replace(/\[([^\]]+)\]\((\/[^)\s]*|https:\/\/[^)\s]+)\)/g, (match, label, url) => {
        const external = url.startsWith('https://');
        return `<a href="${url}"${external ? ' rel="noopener"' : ''}>${label}</a>`;
    });
    return html
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/==(.+?)==/g, '<mark>$1</mark>');
}

/** Même texte sans balisage, pour les données structurées (réponses de FAQ, titres) */
export function plain(text) {
    return String(text)
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
        .replace(/\*\*(.+?)\*\*/g, '$1')
        .replace(/==(.+?)==/g, '$1');
}
